export const ProductQuantity = Object.freeze({
  COUNT: 1,
  INC: 'inc',
});